var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SelectionDialog,{attrs:{"error-message":_setup.errorMessage,"options-show":_setup.optionsShow,"modal-show":_setup.modalShow,"modal-static":_vm.modalStatic,"leaf-icon":"fa fa-folder","items":_setup.items},on:{"onCancel":_setup.onCancel,"onClick":_setup.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }